import { getDefaultStore } from 'jotai';
import { pendingComposerPromptAtom } from '../projects/pendingComposerPrompt';

import { MAKE_AS_WORKFLOW_COMPOSER_PREFILL } from './makeAsWorkflowPrompt';

/** Sends the make-as-workflow follow-up without touching any composer draft. */
export function triggerMakeAsWorkflow(projectId: string): void {
  getDefaultStore().set(pendingComposerPromptAtom, {
    projectId,
    prompt: MAKE_AS_WORKFLOW_COMPOSER_PREFILL,
    submit: true,
  });
}
